<template>
<div>
  <el-container style="display: block;width: 100%;">
     <header>
      <div class="jumbotron" style="margin-bottom: 0">
        <el-row style="min-width: 1200px;">
          <el-col :span="12">
            <div style="width: 100%;height: 100px; margin-left: 10%">
              <el-image
                style="width: auto; height: 86px; margin-left: 10%;padding-top: 20px;width: 52px;
    height: 86px;
    margin-left: 10%;
    padding-top: 18px;"
                :src="logourl"
                fit="contain"
              ></el-image>
              <div style="display: inline-block;line-height: 100px;
    vertical-align: top;
    font-size: 29px;
    color: rgb(74 89 171);
    padding-left: 20px;">
    <div style="line-height: 80px;">福建省机动车检测服务行业协会</div>
    <div style="line-height: 20px;
    height: 20px;
    font-size: 12px;
    font-weight: bolder;
    margin-top: -18px;">FUJIAN MOTOR VEHICLE TESTING SERVICE INDUSTRY ASSOCIATION</div>
    </div>
            </div>
            

          </el-col>
          <el-col :span="12">
            <el-row
              style="
                width: 80%;
                height: 100px;
                margin-left: 10%;
                line-height: 100px;
              "
            >
              <el-input
                style="width: auto; margin-right: 10px"
                placeholder="请输入关键字"
                v-model="keyword"
                @keyup.enter.native="search"
              >
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <el-button type="primary" @click="goLog">登录</el-button>
              <el-button type="primary" @click="goReg">注册</el-button>
            </el-row></el-col
          >
        </el-row>
        <el-row>
          <el-menu
            style="width: 80%; margin-left: 10%"
            :default-active="getActive()"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="app">首页</el-menu-item>
            <el-submenu index="association">
              <template slot="title">协会介绍</template>
              <el-menu-item index="association1">协会简介</el-menu-item>
              <el-menu-item index="association2">协会章程</el-menu-item>
              <el-menu-item index="association3">理事会</el-menu-item>
            </el-submenu>
            <el-submenu index="dynamic">
              <template slot="title">协会动态</template>
              <el-menu-item index="dynamic1">协会动态</el-menu-item>
              <el-menu-item index="dynamic2">会员风采</el-menu-item>
              <el-menu-item index="dynamic3">通知公告</el-menu-item>
            </el-submenu>
            <el-submenu index="news">
              <template slot="title">新闻动态</template>
              <el-menu-item index="news1">行业要闻</el-menu-item>
              <el-menu-item index="news2">人才需求</el-menu-item>
            </el-submenu>
            <el-submenu index="laws">
              <template slot="title">法律法规</template>
              <el-menu-item index="laws1">法律法规</el-menu-item>
              <el-menu-item index="laws2">规范性文件</el-menu-item>
              <el-menu-item index="laws3">相关标准</el-menu-item>
              <el-menu-item index="laws4">标准解读</el-menu-item>
            </el-submenu>
            <el-menu-item index="dangjian">党建工作</el-menu-item>
            <el-menu-item index="contact">联系我们</el-menu-item>
          </el-menu>
        </el-row>
      </div>
      <el-divider style="margin-bottom: 0"></el-divider>
    </header>
  </el-container>
  <div>
        <el-image style="max-height: 300px;width: 100%" fit="fill" :src="bannerurl"></el-image>
      </div>
</div>
  
</template>

<script>
export default {
  name: 'Header',
  props: {
    activeIndex: String,
    bannerurl: {
      default: '/images/index/banner1.jpg'
    },
    logourl: {
      default: '/images/login/log.jpg'
    }
  },
  data() {
    return {
      keyword: this.$route.query.keyword
    };
  },
  methods: {
    getActive() {
      let active = this.$props.activeIndex
      if (this.$route.query.tab) {
        active = this.$route.name + this.$route.query.tab || this.$props.activeIndex
      }
      return active
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      if (keyPath.length > 1) {
        this.$router.push({ name: keyPath[0], query: {
          tab: keyPath[1].replace(keyPath[0], '')
        } });
      } else {
        this.$router.push({ name: keyPath[0] });
      }
    },
    search() {
      this.$router.push({ name: 'list', query: {
        keyword: this.keyword
      } });
    },
    goReg() {
      this.$router.push({ name: 'register' });
    },
    goLog() {
      this.$router.push({ name: "login" });
    },
  }
}
</script>
<style>
.el-tabs--card>.el-tabs__header .el-tabs__nav {
    border: 1px solid #E4E7ED;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    border: none;
    background: rgb(1 20 36 / 83%);
}

.el-tabs--card>.el-tabs__header .el-tabs__item {
    border-bottom: none;
    border-left: none;
    transition: color .3s cubic-bezier(.645,.045,.355,1),padding .3s cubic-bezier(.645,.045,.355,1);
    color: cornflowerblue;
}

.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    border: none;
    color: #fff;
}
.el-tabs--card>.el-tabs__header .el-tabs__item.is-active:hover {
    border: none;
    color: #fff;
}

.el-tabs--card>.el-tabs__header .el-tabs__item:hover {
    border: none;
    color: #fff;
    color: cornflowerblue;
}

.el-menu--horizontal .el-menu .el-menu-item.is-active, .el-menu--horizontal .el-menu .el-submenu.is-active>.el-submenu__title {
    color: #409EFF;
}
.el-menu-item {
    font-size: 14px;
    color: cornflowerblue;
    padding: 0 52px;
    cursor: pointer;
    transition: border-color .3s,background-color .3s,color .3s;
    box-sizing: border-box;
}
.el-divider--horizontal {
  margin-top: 0px;
  margin-bottom: 0;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
*, *::before, *::after {
    box-sizing: border-box;
}
.footer {
    background: rgb(1 20 36 / 83%);
}
.footer .nav-two {
    min-height: 200px;
    padding-top: 10px;
}
@media (min-width: 1200px)
.container {
    max-width: 1140px;
}
@media (min-width: 992px)
.container {
    max-width: 960px;
}
@media (min-width: 768px)
.container {
    max-width: 720px;
}
@media (min-width: 576px)
.container {
    max-width: 540px;
}
.container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}
ol, ul, dl {
    margin-top: 0;
    margin-bottom: 1rem;
}
.footer .nav-two ul li {
    float: left;
    width: 10%;
    height: 100px;
    list-style: none;
}
.footer .nav-two ul li a {
    color: #fff;
    display: block;
    margin-bottom: 10px;
    text-decoration: none;
    cursor: pointer;
}
.footer .nav-two ul li a:hover {
  color: cornflowerblue;
}
.footer .nav-two ul li a h1 {
    font-size: 16px;
    margin-bottom: 30px;
}
.clear {
    clear: both;
}
.footer .copyRight {
    height: auto;
    padding: 24px 0px;
}
.footer .copyRight p {
    color: #fff;
}
.footer .copyRight p:last-child {
    line-height: 25px;
    height: 25px;
}
.footer .copyRight p a {
    margin: 0px 10px;
    color: #fff;
}
.footer .copyRight p:last-child a:last-child {
    float: right;
}
.footer .copyRight p:last-child a:last-child img {
    margin-right: 10px;
    width: 30px;
    vertical-align: middle;
}
.el-footer {
    padding: 0px;
    box-sizing: border-box;
    flex-shrink: 0;
}
.dIndex {
  box-sizing: "border-box"; 
  margin-bottom: 1rem; 
  color: rgb(72, 73, 73); 
  text-indent: 1rem;
  font-size: 16px; 
  line-height: 30px; 
}
.detail_line {
  text-indent: 1rem;
  box-sizing: "border-box"; 
  margin-bottom: 1rem; 
  color: rgb(72, 73, 73); 
  font-size: 16px; 
  line-height: 30px; 
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  background-color: rgb(255, 255, 255);
}
.detail_title {
  text-align: center;
  font-weight: bold;
}
</style>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
a {
  color: #42b983;
}
</style>
